module.exports = __webpack_public_path__ + "static/media/29DUNON14.e44d8369.jpg";